module.exports = {" _key":"@dojo/widgets/radio-group","root":"radio-group-m__root__x5iTH","legend":"radio-group-m__legend__RLkLC"};